import { render } from "./CreateTask.vue?vue&type=template&id=8506c9c2"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"

import "./CreateTask.vue?vue&type=style&index=0&id=8506c9c2&lang=css"

import exportComponent from "/home/debian/plan.docks40.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__